<h2 mat-dialog-title>Select a Contact</h2>

<mat-dialog-content fxFlex>
  <mat-divider></mat-divider>

  <mat-card appearance="outlined" id="serviceRequest">
    <mat-card-header>
      Service Request
    </mat-card-header>

    <mat-card-content fxLayoutAlign="space-between center">
      @if (requestCard) {
        <div>
          <div fxFlex>
            <div class="label">Reference</div>
            <div class="value">{{requestCard.Reference}}</div>
          </div>
          <div fxFlex>
            <div class="label">Contact</div>
            <div class="value">{{requestCard.Name}}</div>
          </div>
          <div fxFlex>
            <div class="label">Service Address</div>
            <div class="value">{{requestCard.Address}}</div>
          </div>
          <div fxFlex>
            <div class="label">Connect Date</div>
            <div class="value">{{requestCard.ConnectDate}}</div>
          </div>
          <div fxFlex>
            <div class="label">Phone Number</div>
            <div class="value">{{requestCard.PhoneNumber}}</div>
          </div>
          <div fxFlex>
            <div class="label">Notes</div>
            <div class="value">{{requestCard.Notes}}</div>
          </div>
        </div>
      }
    </mat-card-content>
  </mat-card>

  <mat-divider></mat-divider>

  <mat-card appearance="outlined" id="smartCards">
    <mat-card-header>
      Contacts
    </mat-card-header>

    <mat-card-content fxLayout="column" id="smartCardsContent">
      <form [formGroup]="tableForm">
        @if (noData) {
          <div>No contact matches found</div>
        }

        @if (!noData) {
          <table mat-table fxFill [dataSource]="tableData" formArrayName="rows">
            <ng-container matColumnDef="Select">
              <th mat-header-cell *matHeaderCellDef>Select</th>
              <td mat-cell *matCellDef="let row; let i = index">
                <div [formGroupName]="i">
                  <lgd-checkbox controlName="selected">
                  </lgd-checkbox>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="Name">
              <th mat-header-cell *matHeaderCellDef>Contact Name</th>
              <td mat-cell *matCellDef="let row">{{row.Name}}</td>
            </ng-container>
            <ng-container matColumnDef="Address">
              <th mat-header-cell *matHeaderCellDef>Mailing Address</th>
              <td mat-cell *matCellDef="let row">{{row.Address}}</td>
            </ng-container>
            <ng-container matColumnDef="Phone">
              <th mat-header-cell *matHeaderCellDef>Phone Number</th>
              <td mat-cell *matCellDef="let row">{{row.Phone}}</td>
            </ng-container>
            <ng-container matColumnDef="DriversLicense">
              <th mat-header-cell *matHeaderCellDef>Drivers License #</th>
              <td mat-cell *matCellDef="let row">{{row.DriversLicense}}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
            <tr mat-row *matRowDef="let myRowData; columns: columnNames"></tr>
          </table>
        }
      </form>

    </mat-card-content>

    <mat-progress-bar [fxShow]="!isLoaded" mode="indeterminate"></mat-progress-bar>
  </mat-card>
</mat-dialog-content>

<mat-dialog-actions fxLayoutAlign="end start">
  <button mat-button color="primary" (click)="cancel()">Cancel</button>
  @if (selectionManager.selected[0]) {
    <button mat-button color="primary" (click)="continue()">Continue</button>
  }
  <button mat-button color="primary" (click)="newContact()">Add New</button>
</mat-dialog-actions>
